import { ca } from '@cian/analytics';

export const trackSafeRentDescriptionShow = (id: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'SafeRent',
    action: 'Show',
    label: 'Arrange_inspection_banner',
    products: [{ id }],
    page: {
      pageType: 'Card',
      siteType: 'desktop',
    },
  });
};

export const trackSafeRentDescriptionClick = (id: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'SafeRent',
    action: 'Click',
    label: 'Arrange_inspection_banner_button',
    products: [{ id }],
    page: {
      pageType: 'Card',
      siteType: 'desktop',
    },
  });
};
